import 'bootstrap/js/dist/dropdown';
import $ from 'jquery';

$(document).ready(function() {
  updateNavWithQueryParams();

  // Listen for hash changes (custom event from Vue router)
  window.addEventListener('vue-route-change', function() {
    updateNavWithQueryParams();
  });
});

function updateNavWithQueryParams() {
  const currentPath = window.location.pathname;
  const currentHash = window.location.hash;

  // Remove active class from all links first
  $('#stations-navbar a[href^="/stations"]').removeClass('active');
  $('#stations-navbar .dropdown-toggle').removeClass('active');

  // Map hash routes to nav paths
  const hashToPathMap = {
    '#/find/nearest': '/stations',
    '#/find/route': '/stations/route',
    '#/analyze': '/stations/counts'
  };

  // Get the actual path to match (use hash mapping if exists)
  const pathToMatch = hashToPathMap[currentHash] || currentPath;

  // Update all nav links
  $('#stations-navbar a[href^="/stations"]').each(function() {
    const $link = $(this);
    const href = $link.attr('href');
    const url = new URL(href, window.location.origin);

    // Add active class if it matches current page
    if (url.pathname === pathToMatch) {
      $link.addClass('active');

      // Add active class to parent dropdown toggle
      $link.closest('.dropdown').find('.dropdown-toggle').addClass('active');
    }
  });
}
